














import { debounce } from "lodash";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class Control extends Vue {
  private isEditing = false;

  @Prop({ required: true })
  private width: number;

  @Prop({ required: true })
  private value: number;

  @Prop({ required: false })
  private min: number;

  @Prop({ required: false })
  private max: number;

  @Prop({ default: () => (x) => true })
  private validator: (number) => boolean;

  private get isValid() {
    return this.validator(this.value);
  }

  private get isStable() {
    return this.isValid && !this.isEditing;
  }

  private debouncedOnInput = debounce(this.onInput, 500);

  private onInput(value: string) {
    const number = parseInt(value, 10);
    this.$emit("input", number);

    if (this.validator(number)) {
      this.$emit("valid-input", number);
    }

    this.isEditing = false;
  }

  @Watch("isStable")
  private onValidityChange(curr: boolean, old: boolean) {
    if (curr === old) {
      return;
    }

    this.$emit("stable", curr);
  }
}
